<div class="account-owner-container">
  <!-- Person Owner Strategy -->
  <ng-container *ngIf="selectedAccountOwnerType === AccountOwnerType.INDIVIDUAL_BY_NAME">
    <app-person-owner
      [accountType]="accountType"
      [isEditMode]="isEditMode"
      [isJointOwnerToggleEnabled]="isJointOwnerToggleEnabled"
      (ownerChange)="onOwnerSelectionChange()"
      (strategyReady)="setStrategy($event)"
    >
    </app-person-owner>
  </ng-container>

  <!-- Trust Owner Strategy -->
  <ng-container *ngIf="selectedAccountOwnerType === AccountOwnerType.TRUST">
    <app-trust-owner
      [accountType]="accountType"
      [isEditMode]="isEditMode"
      (ownerChange)="onOwnerSelectionChange()"
      (strategyReady)="setStrategy($event)"
    >
    </app-trust-owner>
  </ng-container>

  <!-- Business Owner Strategy (Future) -->
  <ng-container *ngIf="selectedAccountOwnerType === AccountOwnerType.BUSINESS">
    <div class="owner-strategy-placeholder">
      <p>Business Owner Component (Future Implementation)</p>
      <p>Owner Type: {{ selectedAccountOwnerType }}</p>
    </div>
  </ng-container>

  <!-- Charitable Owner Strategy (Future) -->
  <ng-container *ngIf="selectedAccountOwnerType === AccountOwnerType.CHARITY">
    <div class="owner-strategy-placeholder">
      <p>Charitable Owner Component (Future Implementation)</p>
      <p>Owner Type: {{ selectedAccountOwnerType }}</p>
    </div>
  </ng-container>
</div>
